import React, { SyntheticEvent, KeyboardEvent } from 'react';
import cx from 'classnames';

import './input.css';

export const Input = ({
    addClasses,
    autoComplete,
    dataCy,
    disabled,
    handleBlur,
    handleChange,
    handleKeyPress,
    icon,
    inputId,
    label,
    labelClasses,
    padding = 'large',
    placeholder,
    tabIndex,
    type = 'text',
    value,
    width,
}: InputProps): JSX.Element => {
    const classNames = cx(
        'input',
        'bg-no-repeat',
        'w-full',
        'rounded',
        {
            'small-padding': padding === 'small',
            'large-padding': padding === 'large',
            'with-icon': icon,
            'p-2': padding === 'small',
            'p-3': padding === 'large',
        },
        addClasses,
        icon,
    );

    return (
        <label
            className={cx('flex border-none rounded', labelClasses)}
            htmlFor={inputId}
        >
            {label && <div className="flex-none self-center pr-2">{label}</div>}
            <input
                autoComplete={autoComplete}
                className={classNames}
                data-cy={dataCy}
                disabled={disabled}
                type={type}
                id={inputId}
                value={value}
                onChange={(e: SyntheticEvent): void => {
                    if (handleChange) {
                        const inputValue = (e.target as HTMLInputElement).value;

                        handleChange(inputValue);
                    }
                }}
                onBlur={(e: SyntheticEvent): void => {
                    if (handleBlur) {
                        const inputValue = (e.target as HTMLInputElement).value;

                        handleBlur(inputValue);
                    }
                }}
                onKeyPress={(e: KeyboardEvent): void => {
                    if (handleKeyPress) {
                        handleKeyPress(e);
                    }
                }}
                tabIndex={tabIndex}
                placeholder={placeholder}
                style={{
                    width,
                }}
            />
        </label>
    );
};
